import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import ExpandableImageComponent from '../Image/ExpandableImageComponent';
import CheckmarkOrXComponent from '../Table/CheckmarkOrXComponent';
import SortableTableComponent from '../Table/SortableTableComponent';

import { getExportTitle } from '../ViewExport/utils';

import { TABLE_CONSTANTS, TABLE_ID } from '../Table/constants';

import { TABLE_DATA_TYPES } from '../../staticData';
import { history } from '../../store';
import StyledLink from '../StyledLink';
import ListActions from '../Table/ListActions';
import DeliveryTypesListExport from './DeliveryTypesListExport';

const DeliveryTypesListComponent = (props) => {
  const theme = useTheme();
  const { items, onLoad, onDeliveryTypeRemove, match } = props;

  const columns = [
    {
      Header: 'Delivery Type Name',
      id: 'name',
      accessor: ({ name, id, icons }) => {
        const iconUrl = icons?.[0]?.url;
        return (
          <Box display="flex">
            {iconUrl && (
              <Box mr={1}>
                <ExpandableImageComponent
                  src={iconUrl}
                  caption={name}
                  height="3.2rem"
                  isSquare
                />
              </Box>
            )}
            <StyledLink to={`${match.url}/${id}`}>{name}</StyledLink>
          </Box>
        );
      },
      headerClassName: 'sort',
      ordering: 'name',
      dataKey: 'name',
      filter: true,
    },
    {
      Header: 'Available in Countries',
      id: 'countriesList',
      accessor: 'countriesList',
      headerClassName: 'sort',
      ordering: 'countriesList',
      dataKey: 'countriesList',
      filter: true,
    },
    {
      Header: 'Is Enabled',
      id: 'enabled',
      accessor: ({ enabled }) => <CheckmarkOrXComponent value={enabled} />,
      headerClassName: 'sort',
      ordering: 'enabled',
      dataKey: 'enabled',
      filter: true,
    },
    {
      Header: 'Defaulted on for all buildings',
      id: 'initialValueForBuildings',
      accessor: ({ initialValueForBuildings }) => (
        <CheckmarkOrXComponent value={initialValueForBuildings} />
      ),
      headerClassName: 'sort',
      ordering: 'initialValueForBuildings',
      dataKey: 'initialValueForBuildings',
      filter: true,
    },
    {
      Header: 'Actions',
      id: 'actions',
      fixed: 'right',
      accessor: (entry) => {
        const deliveryTypeId = entry?.id;
        const actions = [
          {
            label: 'Edit',
            onClick: () => history.push(`${match.url}/${deliveryTypeId}`),
          },
          {
            label: 'Remove',
            color: theme.palette.secondary.main,
            onClick: () => onDeliveryTypeRemove(deliveryTypeId),
          },
        ];
        return <ListActions actions={actions} isFullWidth />;
      },
      sortable: false,
      width: 120,
    },
  ];

  const action = [
    {
      label: 'Add Delivery Type',
      url: `${match.url}/create`,
    },
  ];

  const title = 'Delivery Types Management';
  const exportTitle = getExportTitle(title);
  const getExportActions = (entries) => {
    const onExport = () => ({ data: { results: entries } });
    const exportActions = (
      <DeliveryTypesListExport
        title={exportTitle}
        getDataForExport={onExport}
        columns={columns}
      />
    );
    return exportActions;
  };

  return (
    <SortableTableComponent
      onLoad={onLoad}
      tableId={TABLE_ID.deliveryTypesManagement}
      title="Delivery Types Management"
      columns={columns}
      defaultSort={TABLE_CONSTANTS.name}
      defaultSortKey="name"
      entries={items}
      pluralModelName="deliveryManagement"
      action={<ListActions actions={action} />}
      tableDataType={TABLE_DATA_TYPES.types}
      getExportActions={getExportActions}
    />
  );
};

DeliveryTypesListComponent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  items: PropTypes.instanceOf(Array).isRequired,
  onLoad: PropTypes.func.isRequired,
  onDeliveryTypeRemove: PropTypes.func.isRequired,
};

export default DeliveryTypesListComponent;
